import AccessToken from '~/Api/Authentication/AccessToken';
import mapAccessToken from '~/Api/Authentication/mapAccessToken';
import ApiClient, { ApiClientErrorResponse } from '~/ApiClient';

import PasswordLoginErrorResponse from './PasswordLoginErrorResponse';

export interface Result {
	accessToken: AccessToken;
	gdprTermsConsent: boolean;
}

export default function passwordLogin(client: ApiClient, email: string, password: string): Promise<Result> {
	const body = { email, password };

	return client
		.unauthenticatedFetch('authentication/password/login', {
			method: 'POST',
			body: JSON.stringify(body),
		})
		.then((response) => response.json())
		.then((response) => ({
			accessToken: mapAccessToken(response.accessToken),
			gdprTermsConsent: response.gdprTermsConsent,
		}))
		.catch((response) => ApiClientErrorResponse.wrapError(response, PasswordLoginErrorResponse));
}
